import React from 'react';

function Education() {
    return (
        <>
            <section className="education" id="education">
                <div className="education-text">
                    <div className="section-header">
                        <h2>EDUCATION</h2>
                    </div>

                    <div className="card">
                        <div className="school">
                            <h3>M.S. COMPUTER SCIENCE</h3>
                            <h3 className="school-name">GEORGIA INSTITUTE OF TECHNOLOGY</h3>
                        </div>
                        <div className="dates">
                            <span>January 2025 - December 2026</span>
                        </div>
                    </div>

                    <div className="card">
                        <div className="school">
                            <h3>M.S. ANALYTICS</h3>
                            <h3 className="school-name">GEORGIA INSTITUTE OF TECHNOLOGY</h3>
                        </div>
                        <div className="dates">
                            <span>August 2020 - May 2023</span>
                        </div>
                    </div>

                    <div className="card">
                        <div className="school">
                            <h3>B.S. PHARMACEUTICAL SCIENCES</h3>
                            <h3 className="school-name">UNIVERSITY OF CALIFORNIA, IRVINE</h3>
                        </div>
                        <div className="dates">
                            <span>September 2012 - May 2017</span>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Education